import { ctaDesc, ctaTitle } from "@/lib/seo";
import { createFileRoute, notFound } from "@tanstack/react-router";
import ApostilleProductPage from "@/components/ApostilleProductPage";
import { getApostilleProduct, APOSTILLE_PRODUCTS } from "@/data/apostille-products";
import { apostilleProductGraph, defaultApostilleProductFaqs } from "@/lib/apostille-product-schema";
import { BRAND_URL } from "@/lib/brand";

export const Route = createFileRoute("/apostille/products/$slug")({
  loader: ({ params }) => {
    const p = getApostilleProduct(params.slug);
    if (!p) throw notFound();
    return { product: p };
  },
  head: ({ loaderData, params }) => {
    if (!loaderData) return { meta: [{ title: ctaTitle("ไม่พบบริการ", "/apostille/products/$slug", "th")}, { name: "robots", content: "noindex" }] };
    const p = loaderData.product;
    const path = `/apostille/products/${params.slug}`;
    const url = `${BRAND_URL}${path}`;
    const title = `Apostille ${p.nameTh} — รับรองกรมการกงสุล | ${p.turnaround}`;
    const desc = p.shortDescTh + " · แปล + Notary + MFA + Apostille ครบในสำนักงานเดียว รองรับ 130 ประเทศ Hague";
    const faqs = defaultApostilleProductFaqs(p, "th");
    return {
      meta: [
        { title: ctaTitle(title, "/apostille/products/$slug", "th") }, { name: "description", content: ctaDesc(desc, "/apostille/products/$slug", "th")},
        { property: "og:title", content: ctaTitle(title, "/apostille/products/$slug", "th")},
        { property: "og:description", content: ctaDesc(desc, "/apostille/products/$slug", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "product" },
        { property: "og:locale", content: "th_TH" },
        { property: "product:price:amount", content: String(p.priceMid) },
        { property: "product:price:currency", content: "THB" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "th-TH", href: url },
        { rel: "alternate", hrefLang: "en", href: `${BRAND_URL}/en/apostille/products/${params.slug}` },
        { rel: "alternate", hrefLang: "x-default", href: url },
      ],
      scripts: [{
        type: "application/ld+json",
        children: JSON.stringify(apostilleProductGraph({ product: p, locale: "th", path, faqs })),
      }],
    };
  },
  notFoundComponent: () => <div className="p-16 text-center">ไม่พบบริการที่ค้นหา</div>,
  component: () => {
    const { product } = Route.useLoaderData();
    return <ApostilleProductPage product={product} locale="th" faqs={defaultApostilleProductFaqs(product, "th")} />;
  },
});

export const APOSTILLE_PRODUCT_SLUGS = APOSTILLE_PRODUCTS.map((p) => p.slug);
